import { ListItem } from '@mui/material';
import { styled } from '@mui/material/styles';
import Colors from '../../../../../ui/layout/theme/utils/colors';

export const StyledMenuListItem = styled(ListItem)(({ theme }) => ({
  color: Colors.almost_black,
  backgroundColor: Colors.white,
  '&:hover': {
    backgroundColor: Colors.titan_white,
    color: Colors.almost_black,
  },
}));
